import React from "react";

const Footer = () => {
  return (
    <>
      {/* <!-- footer area start --> */}
      <footer>
        <div className="tp-footer__area black-bg">
          <div className="tp-footer">
            {/* <!-- main-footer start  --> */}
            <div className="tp-footer__main">
              <div className="container">
                <div className="tp-footer-border pt-60 pb-30">
                  <div className="row">
                    <div className="col-lg-3 col-md-6">
                      <div className="tp-footer__widget tp-footer__2 pb-30">
                        <h3 className="tp-footer__widget-title text-white">Company</h3>
                        <ul>
                          <li><a href="about">About us</a></li>
                          <li><a href="/contact">Contact us</a></li>
                          <li><a href="/blog">News</a></li>                        
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="tp-footer__widget tp-footer__2 pb-30">
                        <h3 className="tp-footer__widget-title text-white">Products</h3>
                        <ul>
                          <li><a href="#">Bulk SMS</a></li>
                          <li><a href="#">USSD</a></li>
                          <li><a href="#">Shortcode</a></li>
                          <li><a href="#">Ring Back Tone</a></li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 ">
                      <div className="tp-footer__widget tp-footer__2  pb-30">
                        <h3 className="tp-footer__widget-title text-white">Resources</h3>
                        <ul>
                          <li><a href="#">Support</a></li>
                          <li><a href="https://portal.onfonmedia.co.ke/" target="_blank">Portal</a></li>
                          <li><a href="#">Services</a></li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="tp-footer__widget tp-footer__2  pb-30">
                        <h3 className="tp-footer__widget-title text-white">Legal</h3>
                        <ul>
                          <li><a href="">Terms & Condition</a></li>
                          <li><a href="">Privacy Policy</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- main footer end  --> */}
          </div>
        </div>

        {/* <!-- footer copy right --> */}
        <div className="top-footer-copyright pt-30 black-bg">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-12">
                <div className="tp-copyrigh-text mb-30">
                  <span>
                    © {new Date().getFullYear()} Onfon Media - Innovate . Transparent . All Rights Reserved.
                  </span>
                </div>
              </div>
              <div className="col-md-4 col-12">
                <div className="tp-footer-social-icon mb-30 text-md-end">
                  <ul>
                    <li><a href="https://www.facebook.com/onfonmedial"><i className="fab fa-facebook"></i></a></li>
                    <li><a href="#"><i className="fab fa-twitter"></i></a></li>
                    <li><a href="#"><i className="fab fa-instagram"></i></a></li>
                    <li><a href="#"><i className="fab fa-youtube"></i></a></li>
                    <li><a href="#"><i className="fab fa-linkedin"></i></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- footer copyright end  --> */}
      </footer>
      {/* <!-- footer area end --> */}
    </>
  );
};

export default Footer;
